// 法语
module.exports = {
    public: {
        confirm: 'Confirmer',
        cancel: 'Annuler',
        reset: 'Réinitialiser',
        search: 'Rechercher',
        RefreshSucceeded: 'Rafraîchissement réussi',
        noMoreData: 'Plus de données',
        pullingText: 'Tirez pour rafraîchir...',
        ReleaseText: 'Relâchez pour rafraîchir...',
        loadingText: 'Chargement...',
        noData: 'Aucun enregistrement',
        copyTxt: 'Copier',
        copySuccess: 'Copie réussie',
        amount: 'Montant',
        buy: 'Acheter',
        orderNo: 'Numéro de commande',
        selectLang: 'Choisir la langue',
        light: 'Clair',
        dark: 'Sombre',
        All: 'Tout',
        DigitalCurrency: 'Crypto-monnaie',
        foreignExchange: 'Forex',
        futures: 'Futures',
        stockIndex: 'Indice boursier',
        stock: 'Actions',
        BalanceNot: 'Solde insuffisant',
        optional: 'Choix',
        market: 'Marché',
        USDTcontract: 'Contrat USDT',
        Fiatcurrencycontract: 'Contrat Fiat',
        spot: 'Spot',
        secondContract: 'Contrat à la seconde',
        emptyTxt: 'Aucun enregistrement',
        down: 'Télécharger',
    },
    tabBar: {
        home: 'Accueil',
        market: 'Découvrir',
        trade: 'Échanger',
        heel: 'Finances',
        asset: 'Actifs',
    },
    about: {
        title: 'À propos de nous',
        version: 'Version',
        about: 'À propos',
        ProductIntroduction: 'Présentation du produit',
        Termofservice: 'Conditions d\'utilisation',
        PrivacyAgreement: 'Accord de confidentialité',
        Riskstatement: 'Déclaration de risque',
        whitePaper: 'Livre blanc',
    },
    asset: {
        Overview: 'Aperçu général',
        contract: 'Contrat',
        wallet: 'Portefeuille',
        Totalassetvaluation: 'Évaluation totale des actifs',
        supportswithdrawal: 'Tous les actifs déposés peuvent être retirés',
        Recharge: 'Recharger',
        Contractaccount: 'Compte contrat',
        Spotaccount: 'Compte spot',
        Walletaccount: 'Compte portefeuille',
        ValuationContractAssets: 'Évaluation des actifs du contrat',
        profitloss: 'P&L',
        Transfer: 'Transfert',
        occupy: 'Verrouillage',
        available: 'Disponible',
        Viewallpositions: 'Voir toutes les positions',
        Valuationspotassets: 'Évaluation des actifs spot',
        Hidezerobalanceassets: 'Masquer les actifs à solde nul',
        balance: 'Solde',
        ValuationWalletAssets: 'Évaluation des actifs du portefeuille',
        Withdrawal: 'Retirer',
        Walletbalance: 'Solde du portefeuille',
        Cryptocurrencyrecharge: 'Recharge crypto',
        Fiatcurrencyrecharge: 'Recharge fiat',
        From: 'De',
        To: 'À',
        UsdtContractaccount: 'Compte contrat USDT',
        FiatContractaccount: 'Compte contrat fiat',
        Currency: 'Devise',
        quantity: 'Quantité',
        availablebalance: 'Solde disponible',
        Insufficientavailablebalance: 'Solde disponible insuffisant',
        Transfersuccessful: 'Transfert réussi',
        flashcash: 'Échange rapide',
        flashcashsuccessful: 'Échange rapide réussi',
    },
    auth: {
        title: 'Vérification d\'identité',
        gj: 'Nationalité',
        tipsgj: 'Veuillez sélectionner la nationalité',
        userName: 'Nom réel',
        tips1: 'Veuillez entrer votre nom réel',
        IDNumber: 'Numéro de pièce d\'identité',
        tips2: 'Veuillez entrer votre numéro de pièce d\'identité',
        base: 'Vérification de base',
        high: 'Vérification avancée',
        zmz: 'Photo recto pièce',
        bmz: 'Photo verso pièce',
        tips3: 'Veuillez télécharger la photo recto de la pièce',
        tips4: 'Veuillez télécharger la photo verso de la pièce',
        btn: 'Soumettre',
        upbtn: 'Modifier la pièce',
        subMsg: 'Soumis avec succès, veuillez attendre la vérification',
        upMsg: 'Après modification, une nouvelle vérification sera effectuée, confirmer la modification ?',
        wait: 'En attente de vérification',
        fail: 'Vérification échouée',
        success: 'Vérification réussie',
        cardType: 'Type de pièce',
        idCard: 'Carte d\'identité',
        passport: 'Passeport',
        driverlicense: 'Permis de conduire',
        AssetCertification: 'Certification des actifs',
        AccountType: 'Type de compte',
        holdingamount: 'Montant détenu',
        Accountscreenshot: 'Capture d’écran du compte',
        bankaccount: 'Compte bancaire',
        IRAaccount: 'Compte IRA',
        stockaccount: 'Compte boursier',
        other: 'Autre',
        AccountTypetips: 'Veuillez sélectionner le type de compte',
        Accountscreenshottips: 'Veuillez téléverser la capture d’écran du compte',
    },
    activity: {
        inviteTxt: 'Pour chaque ami invité, vous recevez {amount} USD, avec une commission jusqu’à 3 niveaux',
        invitebtn: 'Inviter et gagner une commission',
        rechargeTxt: 'Lorsque votre filleul effectue un rechargement, vous recevez {amount}% de commission, jusqu’à 3 niveaux',
        rechargebtn: 'Commission de recharge',
        authTxt: 'Recevez {amount} USD dès la validation de votre identité',
        authbtn: 'Validation d’identité',
        inviteRewardTxt: '<p><strong>Invitez des amis, obtenez facilement 30 USD</strong></p><p><br></p><p>1. Objectif de l\'activité</p><p><br></p><p>Utilisateurs ciblés : les nouveaux et anciens utilisateurs peuvent participer, encourageant les utilisateurs existants à inviter activement leurs amis à s\'inscrire et à effectuer des opérations spécifiques, afin d\'élargir la base d\'utilisateurs de la plateforme.</p><p>Demande principale : grâce au mécanisme de recommandation, permettre aux nouveaux utilisateurs de s\'installer rapidement et de générer une croissance exponentielle, tout en offrant aux parrains des récompenses concrètes pour renforcer la rétention et la fidélité des utilisateurs.</p><p><br></p><p>2. Durée de l\'activité</p><p><br></p><p>Du 20 mai 2023 – valable à long terme (des vérifications régulières ou une fin seront annoncées séparément)</p><p><br></p><p>3. Participants</p><p><br></p><p>Tout utilisateur inscrit sur la plateforme et ayant complété la vérification d\'identité de base peut être parrain (A) ;</p><p>Le filleul (B) doit s\'inscrire via un lien d\'invitation ou un code et compléter la vérification d\'identité pour être valide.</p><p><br></p><p>4. Règles de participation</p><p><br></p><p>Méthode d\'invitation</p><p>Le parrain (A) accède à « Page personnelle » → « Inviter des amis » → copie son lien/codes d\'invitation exclusifs.</p><p>Il partage le lien/code avec ses amis (B) qui s\'inscrivent via le site web ou l\'application.</p><p><br></p><p>Exigences pour le filleul</p><p>Le filleul (B) doit utiliser le lien ou le code fourni par le parrain pour s\'inscrire pour la première fois.</p><p>Il doit compléter la vérification d\'identité dans les 7 jours et atteindre le seuil minimum de dépôt (ex : premier dépôt ≥ 1000 USD ou équivalent en tokens).</p><p><br></p><p>Niveaux de parrainage</p><p>L\'activité supporte jusqu\'à trois niveaux de commission.</p><p>Premier niveau (parrainage direct) : A invite directement B.</p><p>Deuxième niveau : B invite C, A reçoit une commission de niveau 2.</p><p>Troisième niveau : C invite D, A reçoit une commission de niveau 3.</p><p>Au-delà du troisième niveau (D invite E et suivants), les commissions ne sont plus attribuées à A.</p><p><br></p><p>5. Détails des récompenses</p><p><br></p><p>Récompense de parrainage de premier niveau (direct)</p><p>Lorsque B effectue un dépôt et valide son identité, A reçoit 30 USD.</p><p><br></p><p>Récompense de parrainage de deuxième niveau (indirect)</p><p>Si B devient parrain et invite C qui remplit les mêmes conditions (vérification + dépôt minimum), A reçoit 15 USD.</p><p><br></p><p>Récompense de parrainage de troisième niveau (deuxième indirect)</p><p>Quand C invite D qui remplit les conditions, A reçoit 10 USD.</p><p><br></p><p>Méthode de versement des récompenses</p><p>Le système identifie automatiquement les relations de parrainage sur trois niveaux, et dès qu\'un filleul (direct ou indirect) remplit les conditions, la récompense correspondante est automatiquement versée sur le compte de A dans un délai de <strong>48 heures</strong>.</p><p><br></p><p><br></p><p>6. Exemple de procédure</p><p><br></p><p>A se connecte à cryptorix, accède à « Page personnelle » → « Inviter des amis » → copie son lien/code d\'invitation.</p><p>A envoie le lien/code à son ami B.</p><p>B clique sur le lien ou entre le code, accède à la page d\'inscription → inscription par e-mail → complète la vérification d\'identité et effectue un dépôt ≥ 1000 USD.</p><p>Après la vérification et le dépôt de B, il contacte le service en ligne pour réclamer la récompense ; après validation du système, 30 USD sont versés à A (dans les 48 heures).</p><p>Si B invite C, et que C remplit aussi les conditions, le système verse automatiquement 15 USD à A ; si C invite D et que D remplit les conditions, 10 USD sont automatiquement versés à A.</p><p><br></p><p>&nbsp;</p><p>7. Contrôle des risques et remarques</p><p><br></p><p>Mesures anti-fraude</p><p>Chaque numéro de téléphone / email ne peut être invité qu\'une seule fois, le système contrôle via IP, carte d\'identité et autres données multidimensionnelles.</p><p>Pour les comportements suspects (mêmes appareils, réseau, nombreuses inscriptions de faible qualité), un contrôle manuel sera effectué et les récompenses peuvent être annulées.</p><p><br></p><p>Sanctions</p><p>En cas de fraude ou de manipulation des récompenses par le parrain ou le filleul, la plateforme se réserve le droit d\'annuler toutes les récompenses concernées et de geler les comptes.</p><p><br></p><p>&nbsp;</p>',
        rechargeRewardTxt: '<p><strong>Commission sur les dépôts des filleuls, profitez des gains sans attente</strong></p><p><br></p><p><strong>1. Objectif de l\'activité</strong></p><p><br></p><p>Utilisateurs ciblés : les parrains (A) ayant validé leur identité, qui peuvent recevoir une commission sur les dépôts de leurs filleuls (B, C, D) sur la plateforme, afin de cultiver une « chaîne de croissance » et d\'augmenter l\'activité des utilisateurs.</p><p><br></p><p>Demande principale : le mécanisme de « commission sur dépôts » lie les dépôts des nouveaux utilisateurs aux intérêts des parrains, créant un cycle vertueux « invitation - dépôt - commission - nouvelle invitation », favorisant la rétention des fonds et l\'activité sur la plateforme.</p><p><br></p><p><strong>2. Durée de l\'activité</strong></p><p><br></p><p>Activité permanente : depuis le 20 mai 2023, valable à long terme, ajustable selon les besoins avec annonce préalable pour changement de taux ou fin.</p><p><br></p><p><strong>3. Participants</strong></p><p><br></p><p>Parrain A : utilisateur ayant validé son identité et ayant invité au moins un filleul (B) validé.</p><p><br></p><p>Filleuls B, C, D : utilisateurs de deuxième et troisième niveau invités par A ou par leurs filleuls, générant une commission pour A lors des dépôts effectués.</p><p><br></p><p><strong>4. Règles de participation</strong></p><p><br></p><p><strong>Relations de niveaux :</strong></p><p><br></p><p>Premier niveau (B direct) : si B effectue un dépôt (monnaie fiduciaire ou cryptomonnaie prise en charge) atteignant le seuil minimum, le système reverse 1% du montant à A (voir règles ci-dessous).</p><p>Deuxième niveau (B invite C) : si C effectue un dépôt, A reçoit 0,5% du montant.</p><p>Troisième niveau (C invite D) : si D effectue un dépôt, A reçoit 0,3% du montant (taux inférieur).</p><p>Seules les commissions jusqu\'au troisième niveau sont versées, les niveaux supérieurs ne génèrent plus de commission pour A.</p><p><br></p><p><strong>Canaux de dépôt et seuil minimum :</strong></p><p><br></p><p>Tous les canaux supportés par la plateforme sont acceptés (monnaie fiduciaire ou crypto multi-réseaux), avec un dépôt minimum par transaction de 1000 USD ou équivalent pour calculer la commission.</p><p><br></p><p><strong>Taux de commission</strong></p><p><br></p><p>Niveau 1 (B) : 1.0% Exemple : dépôt de 1000 USD par B, A reçoit 10 USD</p><p>  </p><p>Niveau 2 (C) : 0.5% Exemple : dépôt de 1000 USD par C, A reçoit 5 USD</p><p><br></p><p>Niveau 3 (D) : 0.3% Exemple : dépôt de 1000 USD par D, A reçoit 3 USD</p><p><br></p><p><strong>Méthode de versement des commissions</strong></p><p><br></p><p>La plateforme verse automatiquement la commission sur le compte trading de A dans les 24 heures suivant le dépôt crédité du filleul ;</p><p>L\'utilisateur peut consulter les détails de ses commissions dans « Mon portefeuille » → « Détails des commissions ».</p><p><br></p><p><strong>5. Exemple de procédure</strong></p><p><br></p><p>A se connecte à l\'application → « Page personnelle » → « Inviter des amis » → copie son lien/code d\'invitation.</p><p>A transmet le lien/code à B.</p><p>B s\'inscrit → complète la vérification d\'identité → effectue un dépôt (au moins 1000 USD).</p><p>Après le dépôt, le système calcule automatiquement : montant total déposé par B × 1% = commission pour A. La commission est créditée dans les 24 heures.</p><p><br></p><p>B devient parrain, invite C. Si C dépose, le système calcule les commissions de B et A :</p><p>B reçoit 1% du dépôt de C ;</p><p>A reçoit 0,5% du dépôt de C.</p><p><br></p><p>C invite D, si D dépose, les commissions de troisième niveau sont versées :</p><p>C reçoit 1% du dépôt de D ;</p><p>B reçoit 0,5% du dépôt de D ;</p><p>A reçoit 0,3% du dépôt de D.</p><p><br></p><p><strong>6. Contrôle des risques et remarques</strong></p><p><br></p><p><strong>Prévention des abus</strong></p><p><br></p><p>Un utilisateur ne peut pas faire des dépôts circulaires avec son propre compte ; la plateforme surveille les petits dépôts multiples et les gros dépôts suivis de retraits rapides, avec audit manuel si nécessaire et annulation des commissions.</p><p>Les dépôts annulés rapidement et présentant des opérations fréquentes peuvent être considérés comme abusifs et entraînent l\'annulation des commissions.</p><p><br></p><p><strong>Conformité</strong></p><p><br></p><p>En cas de détection de blanchiment d\'argent ou risque de fraude, la plateforme peut geler les commissions des utilisateurs concernés et notifier les autorités compétentes.</p><p><br></p><p><br></p>',
        authRewardTxt: '<p><strong>Vérification d\'identité, recevez 50 USD</strong></p><p><br></p><p>1. Objectif de l\'activité</p><p><br></p><p>Utilisateurs ciblés : nouveaux et anciens utilisateurs inscrits sur la plateforme (n\'ayant pas encore validé leur identité) peuvent participer, avec pour but d\'attirer les nouveaux utilisateurs à compléter la vérification d\'identité et d\'encourager ceux hésitant à le faire rapidement.</p><p>Demande principale : stimuler directement les utilisateurs à compléter la vérification via une récompense en espèces, améliorant la qualité du contrôle des risques et la couverture KYC, assurant la conformité de la plateforme.</p><p><br></p><p>2. Durée de l\'activité</p><p><br></p><p>Du 20 mai 2023 – valable à long terme</p><p><br></p><p>3. Participants</p><p><br></p><p>Nouveaux utilisateurs : première inscription sur cryptorix et vérification d\'identité pendant la période de l\'activité.</p><p>Anciens utilisateurs : inscrits avant l\'activité mais n\'ayant pas encore validé leur identité, doivent compléter la vérification pendant la période pour recevoir la récompense.</p><p><br></p><p>4. Règles de participation</p><p><br></p><p>Exigences de vérification</p><p>L\'utilisateur doit télécharger des photos claires des deux faces de la pièce d\'identité (carte d\'identité, passeport, permis de conduire), ainsi qu\'une photo en buste tenant la pièce ;</p><p>La reconnaissance faciale doit se faire dans de bonnes conditions d\'éclairage, sans obstruction du visage, conforme à la détection de vie de la plateforme ;</p><p>Après soumission, l\'examen prend généralement moins de 24 heures.</p><p><br></p><p>Montant de la récompense</p><p>Tous les utilisateurs validant leur identité pendant la période de l\'activité (nouveaux et anciens) reçoivent 50 USD.</p><p><br></p><p>Méthode et délai de versement</p><p>Après validation, la plateforme verse 50 USD sur le compte contrat monnaie fiduciaire dans les 24 heures ; le retrait est possible après 10 transactions normales.</p><p><br></p><p>En cas d\'incomplétude ou de refus, l\'utilisateur doit compléter les informations et repasser la validation pour recevoir la récompense.</p><p><br></p><p>5. Exemple de procédure</p><p><br></p><p>Utilisateur se connecte à l\'application → « Vérification d\'identité » → commence la procédure.</p><p>Télécharge les photos de la pièce d\'identité (recto-verso).</p><p>Le système vérifie automatiquement, si refusé l\'utilisateur doit refaire les photos.</p><p>Après validation, la récompense de 50 USD est versée sur le compte contrat monnaie fiduciaire dans les 24 heures.</p><p><br></p><p>6. Contrôle des risques et remarques</p><p><br></p><p>Prévention des fraudes</p><p>Une pièce d\'identité ne peut être utilisée qu\'une seule fois pour la récompense ; le système contrôle les demandes multiples sur une même IP ou appareil et peut rejeter ou soumettre à examen manuel.</p><p>Les images falsifiées ou modifiées sont refusées et les comptes bloqués.</p><p><br></p><p>Protection des données</p><p>La plateforme garantit que les données d\'identité et de reconnaissance faciale sont utilisées uniquement pour la conformité et ne sont pas divulguées sans accord ;</p><p>Après validation, les données sont stockées de manière sécurisée conformément aux lois applicables.</p><p><br></p><p><br></p><p>&nbsp;</p>',
    },
    bill: {
        title: 'Détails financiers',
        audit: 'En attente de vérification',
        success: 'Succès',
        refuse: 'Refusé',
        recharge: 'Recharger',
        recharge_currency: 'Recharge crypto',
        recharge_legal: 'Dépôt fiat',
        withdrawal: 'Retirer',
        withdrawal_currency: 'Retrait crypto',
        cancel_withdrawal_currency: 'Annuler retrait crypto',
        withdrawal_legal: 'Retrait fiat',
        cancel_withdrawal_legal: 'Annuler retrait fiat',
        transfer: 'Transfert',
        usdt_contract_wallet: 'Contrat USDT -> Portefeuille',
        legal_contract_wallet: 'Contrat fiat -> Portefeuille',
        coin_currency_wallet: 'Spot -> Portefeuille',
        wallet_usdt_contract: 'Portefeuille -> Contrat USDT',
        wallet_legal_contract: 'Portefeuille -> Contrat fiat',
        wallet_coin_currency: 'Portefeuille -> Spot',
        finance_wallet: 'Finances->Portefeuille',
        wallet_finance: 'Portefeuille->Finances',
        usdt_contract_currency: 'Contrat USDT -> Spot',
        finance_currency: 'Finance -> Spot',
        currency_usdt_contract: 'Spot -> Contrat USDT',
        currency_finance: 'Spot -> Finance',
        legal_contract_currency: 'Contrat en monnaie fiat -> Spot',
        currency_legal_contract: 'Spot -> Contrat en monnaie fiat',
        recharge_reward: 'Commission de recharge du subordonné',
        auth_reward: 'Récompense de vérification d’identité',
        flashcash: 'Échange rapide',
        trade: 'Échange',
        create_order: 'Passer commande',
        settlement_order: 'Règlement de commande',
        cancel_order: 'Annuler commande',
        finance_return: 'Remboursement du capital',
        finance_income: 'Revenus d’investissement',
        other: 'Autre',
        commission_transfer: 'Transfert de commission',
        platform_gift: 'Cadeau de la plateforme',
        system_regulation: 'Changement de solde',
        freeze_thaw: 'Congeler décongeler',
        c2c_create_order: 'C2C Passer commande',
        c2c_cancel_order: 'C2C Annuler commande',
        Currency: 'Devise',
        type: 'Type',
        SelectCurrency: 'Sélectionner la devise',
        SelectType: 'Sélectionner le type',
        SelectDate: 'Sélectionner la date',
        to: 'À',
        Contractfunds: 'Fonds contrat',
        Spotfunds: 'Fonds spot',
        Walletfunds: 'Fonds portefeuille',
        RechargeRecord: 'Historique recharges',
        WithdrawalRecord: 'Historique retraits',
        virtualcoin: 'Crypto-monnaie',
        Legaltender: 'Fiat',
    },
    c2c: {
        limit: 'Limite',
        available: 'Disponible',
        price: 'Prix unitaire',
        needpay: 'Vous devez payer',
        willreceive: 'Vous recevrez',
        Insufficientlimit: 'Limite insuffisante',
        Exceedinglimit: 'Limite dépassée',
        Exceedingavailable: 'Dépasse la disponibilité',
        balance: 'Solde',
        InsufficientBalance: 'Solde insuffisant',
        OrderHistory: 'Historique des commandes',
        quantity: 'Quantité',
        amountmoney: 'Montant',
        OrderNo: 'Numéro de commande',
        inprogress: 'En cours',
        Completed: 'Terminé',
        Cancelled: 'Annulé',
        all: 'Tout',
        chat: 'Chat',
        picture: '[Image]',
        Read: 'Lu',
        Unread: 'Non lu',
        inputTips: 'Entrez votre message ici',
        send: 'Envoyer',
    },
    common: {
        title: 'Toutes les fonctionnalités',
        Depositcoins: 'Dépôt cryptos',
        Rechargefiatcurrency: 'Dépôt fiat',
        Withdraw: 'Retirer',
        documentation: 'Finances',
        Activecenter: 'Centre d\'activités',
        Invitationforrebate: 'Inviter pour remise',
        Detailsoffunds: 'Détails des fonds',
        Positiondetails: 'Détails des positions',
        Notice: 'Informations',
        Aboutus: 'À propos de nous',
        helpcenter: 'Centre d\'aide',
        customer: 'Service client',
        Cryptocurrencywithdrawal: 'Retrait crypto',
        Fiatmoneywithdrawal: 'Retrait fiat',
    },
    forgotPass: {
        title: 'Réinitialiser le mot de passe',
        btn: 'Confirmer',
        Password: 'Nouveau mot de passe',
        placeholder: 'Veuillez entrer un nouveau mot de passe',
        success: 'Réglage réussi',
    },
    finance: {
        financeAssetAmount: 'Valeur estimée des actifs financiers',
        financeAccount: 'Compte financier',
        financefund: 'Fonds financiers',
        financeProduct: 'Produit financier',
        Applynow: 'Souscrire maintenant',
        term: 'Durée',
        investment: 'Montant de l’investissement',
        Mininvestment: 'Investissement minimum',
        Maxinvestment: 'Montant d’investissement maximum',
        buyNum: 'Nombre d’achats',
        Myincome: 'Mes revenus',
        Dailyearnings: 'Revenus quotidiens',
        yieldmaturity: 'Revenus à l’échéance',
        timeaxis: 'Frise chronologique',
        Subscriptiondate: 'Date de souscription',
        valuedate: 'Date de valeur',
        duedate: 'Date d’échéance',
        Receiptdate: 'Date de réception',
        day: 'Jour',
        financeOrderList: 'Historique financier',
        interestrate: 'Taux intérêt',
        Revenueamount: 'Montant des revenus',
        Settlementamount: 'Montant du règlement',
        regularly: 'À terme',
        eecurrent: 'À vue',
        redemption: 'Rachat',
        redemptionTips: 'Confirmer le rachat de ce produit financier',
        loan: 'Prêt',
        LoanRange: 'Plage de prêt',
        LoanAmount: 'Montant du prêt',
        loanTerm: 'Durée du prêt',
        Dailyinterestrate: 'Taux d’intérêt quotidien',
        Totalinterest: 'Intérêts totaux',
        Repaymentmethod: 'Mode de remboursement',
        Repaymentofmaturity: 'Remboursement du capital et des intérêts en une seule fois à l’échéance',
        Estimatedreturn: 'Montant estimé à rembourser',
        Ihavereadandagree: 'J’ai lu et j’accepte',
        LoanAgreement: 'Contrat de prêt',
        Immediatelymoney: 'Emprunter immédiatement',
        Minimumloanamount: 'Montant minimum du prêt',
        Maximumloanamount: 'Montant maximum du prêt',
        Applicationsuccessfulreview: 'Demande réussie, en attente de l’examen du système',
        Loanrecords: 'Historique des prêts',
        Pendingreview: 'En attente d’examen',
        issued: 'Décaissé',
        Repaid: 'Remboursé',
        Rejected: 'Rejeté',
        LoanDate: 'Date du prêt',
        AmountDue: 'Montant dû',
        repayment: 'Remboursement',
        homeAddress: 'Adresse détaillée du domicile',
        homeAddressTips: 'Veuillez saisir l’adresse détaillée du domicile',
        emergencyContact: 'Contact d’urgence',
        emergencyContactTips: 'Veuillez saisir le contact d’urgence',
        emergencyPhone: 'Numéro de téléphone du contact d’urgence',
        emergencyPhoneTips: 'Veuillez saisir le numéro de téléphone du contact d’urgence',
        emergencyEmail: 'Email du contact d’urgence',
        emergencyEmailTips: 'Veuillez saisir l’email du contact d’urgence',
        isHouse: 'Possédez-vous un bien immobilier à votre nom',
        houseImg: 'Si vous possédez un bien immobilier, veuillez fournir une image du justificatif de propriété',
        certImg: 'Recto du document (Carte d’identité/Passeport/Permis de conduire)',
        certImgTips: 'Veuillez télécharger le recto du document (Carte d’identité/Passeport/Permis de conduire)',
        certBackImg: 'Verso du document (Carte d’identité/Passeport/Permis de conduire)',
        certBackImgTips: 'Veuillez télécharger le verso du document (Carte d’identité/Passeport/Permis de conduire)',
        trustImg: 'Capture d’écran du score de crédit',
        trustImgTips: 'Veuillez télécharger la capture d’écran du score de crédit',
        yesTxt: 'Oui',
        noTxt: 'Non',
        EstimatedReturn: 'Rendement estimé',
        seeDetail: 'Voir les détails',
        orderDetails: 'Détails de la commande',
        simFinanceTips: 'Veuillez passer à un compte réel pour utiliser la fonction d’investissement',
    },
    heel: {
        tips: 'À venir~',
    },
    home: {
        optional: 'Choix',
        HotList: 'Top tendances',
        more: 'Plus',
        Welcomeback: 'Bon retour',
        loginBtn: 'Se connecter',
        CompleteAuth: 'Complétez la vérification d’identité pour débloquer tous les services',
        authBtn: 'Vérifier maintenant',
    },
    login: {
        title: 'Se connecter',
        Account: 'Compte',
        Password: 'Mot de passe',
        btn: 'Se connecter',
        placeholder: 'Entrez le numéro de téléphone',
        placeholder1: 'Entrez le mot de passe',
        ForgotPassword: 'Mot de passe oublié',
        noAccount: 'Pas de compte ?',
        Registration: 'S\'inscrire',
        server: 'Contacter le service client',
        success: 'Connexion réussie',
        checkedAgree: 'Veuillez d\'abord accepter la politique de confidentialité',
        rememberpassword: 'Se souvenir du mot de passe',
        agreewith: 'Accepter',
        PrivacyAgreement: 'Politique de confidentialité',
    },
    market: {
        product: 'Produit',
        Latestprice: 'Dernier prix',
        volume: 'Volume',
        ChangeRatio: 'Variation',
        Addoptional: 'Ajouter aux favoris',
        optional: 'Favoris',
        market: 'Marché',
        Editselfselection: 'Modifier les favoris',
        operate: 'Opérer',
        SelectAll: 'Tout sélectionner',
        delete: 'Supprimer',
        time: 'Le temps',
    },
    position: {
        title: 'Détails des positions',
        totalassets: 'Actifs totaux',
        profitloss: 'P&L',
        Holdingassets: 'Actifs détenus',
        margin: 'Marge',
        orderAmount: 'Montant de l\'ordre',
        availableassets: 'Actifs disponibles',
        product: 'Produit',
        direction: 'Direction',
        Entrustedprice: 'Prix de l\'ordre',
        Entrustednum: 'Quantité de l\'ordre',
        Currentprice: 'Prix actuel',
        Stoplossprice: 'Prix de stop loss',
        stopSurplusPrice: 'Prix de prise de bénéfice',
        Leverageratio: 'Ratio de levier',
        Entrustedtime: 'Temps de l\'ordre',
        orderno: 'Numéro de commande',
        marketvalue: 'Valeur du marché',
        SettlementPrice: 'Prix de règlement',
        Settlementtime: 'Temps de règlement',
        Settakeprofitloss: 'Définir le stop loss et la prise de bénéfice',
        closeposition: 'Clôturer la position',
        Position: 'Position actuelle',
        commission: 'Ordres historiques',
        Settlement: 'Transactions historiques',
        Settingsuccessful: 'Réglage réussi',
        Confirmclosingorder: 'Confirmer la clôture de l\'ordre',
        Closingsuccessfully: 'Clôture réussie',
        cancelorder: 'Confirmer l\'annulation de l\'ordre',
        Cancelsuccessfully: 'Annulation réussie',
        status: 'Statut',
        changeRate: 'Frais',
    },
    property: {
        title: 'Détails des actifs',
        totalassets: 'Actifs totaux',
        profitloss: 'P&L',
        Holdingassets: 'Actifs détenus',
        margin: 'Marge',
        availableassets: 'Actifs disponibles',
        investmentportfolio: 'Portefeuille d\'investissement',
        Recentincomesituation: 'Situation des revenus récents',
        Seemore: 'Voir plus',
        IncomeDetails: 'Détails des revenus',
    },
    recharge: {
        mixAmount: 'Montant minimum de dépôt',
        subMsg: 'Soumission réussie, veuillez attendre l\'examen',
        amountMsg: 'Veuillez entrer le montant',
        VoucherMsg: 'Veuillez télécharger le justificatif de paiement',
        Depositcoins: 'Déposer des cryptos',
        Rechargecurrency: 'Monnaie de dépôt',
        RechargecurrencyTips: 'Déposez plus de 200 USDT, arrivée rapide',
        Depositaddress: 'Adresse de dépôt',
        Rechargetoaccount: 'Créditer le compte',
        Walletaccount: 'Compte portefeuille',
        Rechargequantity: 'Quantité de dépôt',
        Paymentvoucher: 'Justificatif de paiement',
        Youneedtorecharge: 'Vous devez déposer',
        Rechargenow: 'Déposer maintenant',
        Rechargefiatcurrency: 'Dépôt fiat',
        Topupfiatcurrency: 'Recharger fiat',
        paymentcurrency: 'Monnaie de paiement',
        paymentcurrencyTips: 'Déposez plus de 200 USD, arrivée rapide',
        Fiatcontractaccount: 'Compte contrat fiat',
        Rechargeamount: 'Montant du dépôt',
        Youwillget: 'Vous recevrez',
        network: 'Réseau',
        notsupportedAddress: 'Adresse non supportée',
        selectaccount: 'Veuillez sélectionner un compte',
    },
    register: {
        title: 'S\'inscrire',
        send: 'Envoyer le code',
        Resend: 'Renvoi',
        sendSuccess: 'Envoi réussi',
        PhoneNumber: 'Numéro de téléphone',
        Mailbox: 'E-mail',
        Captcha: 'Code de vérification',
        Password: 'Mot de passe',
        ConfirmPassword: 'Confirmer le mot de passe',
        PromoteCode: 'Code de promotion',
        OrgCode: 'Code de l\'organisation',
        btn: 'S\'inscrire',
        placeholder0: 'Veuillez entrer le numéro de téléphone',
        placeholder1: 'Veuillez entrer le mot de passe',
        placeholder2: 'Veuillez confirmer le mot de passe',
        placeholder3: 'Veuillez entrer l\'ID du parrain',
        placeholder4: 'Veuillez entrer le code de vérification',
        placeholder5: 'Veuillez entrer l\'e-mail',
        emaiError: 'Format d\'e-mail incorrect',
        success: 'Inscription réussie',
        message: 'Le mot de passe doit comporter au moins 6 caractères',
        message1: 'Le mot de passe de confirmation doit comporter au moins 6 caractères',
        message2: 'Les mots de passe ne correspondent pas',
        searchCountryMsg: 'Veuillez entrer le pays et l\'indicatif',
        haveAccount: 'Vous avez déjà un compte ?',
        goLogin: 'Se connecter',
        titleTips: 'Commencez par vous inscrire !',
        Invitationcode: 'Code d\'invitation',
        Iagreewith: 'En créant un compte, j\'accepte les',
        and: 'et',
    },
    safe: {
        SecuritySettings: 'Paramètres de sécurité',
        Accountsecurity: 'Sécurité du compte',
        phone: 'Téléphone',
        Notyetbound: 'Non lié',
        mailbox: 'E-mail',
        Loginpassword: 'Mot de passe',
        Fundcode: 'Code de fonds',
        Settings: 'Paramètres',
        Withdrawaladdressmanagement: 'Gestion des adresses de retrait',
        Addwithdrawaladdress: 'Ajouter une adresse de retrait',
        Withdrawalcurrency: 'Monnaie de retrait',
        Withdrawaladdress: 'Adresse de retrait',
        WithdrawaladdressTips: 'Veuillez entrer l\'adresse de retrait',
        WithdrawaladdressError: 'Veuillez entrer une adresse de retrait valide',
        remark: 'Remarque',
        confirm: 'Confirmer',
        Addedsuccessfully: 'Ajout réussi',
        Pleaseselectcurrency: 'Veuillez sélectionner la monnaie',
        Bindmailbox: 'Lier l\'e-mail',
        Bindmobilephone: 'Lier le téléphone',
        ChangeLoginPassword: 'Modifier le mot de passe',
        Setfundpassword: 'Définir le mot de passe des fonds',
        BindmailboxTips: 'Veuillez d\'abord lier votre e-mail, voulez-vous le faire ?',
        Addnewaddress: 'Ajouter une nouvelle adresse',
        Confirmdeleteaddress: 'Confirmer la suppression de cette adresse de retrait',
    },
    share: {
        title: 'Partager pour gagner',
        commission: 'Commission',
        Commissionrecord: 'Historique des commissions',
        Commissiontransferout: 'Transfert de commission',
        Transferoutrecord: 'Historique des transferts',
        Invitefriends: 'Inviter des amis',
        Invitationrecord: 'Historique des invitations',
        Commissioncommission: 'Commissions',
        ReferralCode: 'Code de parrainage',
        Firstlevelmembers: 'Membres de premier niveau',
        Secondlevelmembers: 'Membres de deuxième niveau',
        Thirdlevelmembers: 'Membres de troisième niveau',
        Transferbalance: 'Transférer vers le solde',
        Confirmtransferout: 'Confirmer le transfert',
        Transfersuccessful: 'Transfert réussi',
        amount: 'Montant du transfert',
        Transferfiaaccount: 'Transférer vers le compte contrat fiat',
    },
    trade: {
        high: 'Prix max 24h',
        low: 'Prix min 24h',
        vol: 'Volume 24h',
        buy: 'Acheter',
        sell: 'Vendre',
        buyBtn: 'Acheter',
        sellBtn: 'Vendre',
        Present: 'Ordre au prix du marché',
        Limit: 'Ordre à cours limité',
        limitMsg: 'Prix',
        markPriceMsg: 'Au meilleur prix actuel',
        num: 'Quantité',
        zyzsSet: 'Définir le stop loss / prise de bénéfices',
        zyPrice: 'Prix de prise de bénéfice',
        zsPrice: 'Prix de stop loss',
        smallMin: 'M',
        hour: 'H',
        dayMin: 'D',
        Position: 'Position',
        Viewalltransactions: 'Voir toutes les transactions',
        product: 'Produit',
        direction: 'Direction',
        Entrustedprice: 'Prix de l\'ordre',
        Entrustednum: 'Quantité de l\'ordre',
        Latestprice: 'Dernier prix',
        volume: 'Volume',
        ChangeRatio: 'Variation',
        buyBtnConfirm: 'Confirmer l\'achat',
        sellBtnConfirm: 'Confirmer la vente',
        totalAmount: 'Montant',
        Margin: 'Marge',
        balance: 'Disponible',
        buyLimtMsg: 'Acheter long uniquement à un prix inférieur au prix du marché',
        sellLimtMsg: 'Vendre short uniquement à un prix supérieur au prix du marché',
        putNummsg: 'Veuillez entrer la quantité',
        putLimitPriceMsg: 'Veuillez entrer le prix limite',
        pleaseAuth: 'Veuillez d\'abord vous authentifier',
        orderSuccess: 'Transaction réussie',
        Fullwarehouse: 'Tout le capital',
        corkado: 'Peut acheter long',
        Kato: 'Acheter long',
        openable: 'Peut acheter short',
        Openempty: 'Acheter short',
        purchasable: 'Peut acheter',
        vendibility: 'Peut vendre',
        Orderconfirmation: 'Confirmer la commande',
        Averageopeningprice: 'Prix d\'ouverture moyen',
        Marketprice: 'Prix du marché',
        Openingquantity: 'Quantité d\'ouverture',
        Stoplossprice: 'Prix de stop loss',
        stopSurplusPrice: 'Prix de prise de bénéfices',
        Averageprice: 'Prix moyen',
        buyLimtMsg2: 'L\'achat doit être inférieur au prix du marché',
        sellLimtMsg2: 'La vente doit être supérieure au prix du marché',
        authTips: 'Veuillez d\'abord vous authentifier, allez vous authentifier ?',
        profundity: 'Profondeur',
        deal: 'Transaction',
        contract: 'Contrat',
        TradeNow: 'Trader maintenant',
        CloseTime: 'Hugh ville',
        buyUp: 'Acheter à la hausse',
        buyDown: 'Acheter à la baisse',
        selectSeconds: "Sélectionner le temps d'expiration",
        buyNums: "Quantité à acheter",
        minbuyNums: "Achat minimum",
        incomeRates: 'Taux de rendement',
        buySuccessTips: 'Achat réussi',
        secondNums: 'Secondes',
        simulatedTrading: 'Trading simulé',
    },
    upPassword: {
        title: 'Modifier le mot de passe',
        oldPassword: 'Ancien mot de passe',
        oldPasswordMsg: 'Veuillez entrer l\'ancien mot de passe',
        newPassword: 'Nouveau mot de passe',
        newPasswordMsg: 'Veuillez entrer un nouveau mot de passe',
        twoPassword: 'Confirmer le mot de passe',
        twoPasswordMsg: 'Veuillez entrer la confirmation du mot de passe',
        twoinputMsg: 'Les mots de passe ne correspondent pas',
        passwordTypeMsg: 'Le mot de passe doit contenir 6 chiffres',
        submsg: 'Modification réussie',
        btn: 'Confirmer la modification',
    },
    user: {
        Avatarchange: 'Changer l\'avatar',
        Replacesuccessfully: 'Changement réussi',
        authenticated: 'Authentifié',
        Notcertifiedyet: 'Non certifié',
        Invitefriends: 'Inviter des amis',
        Activecenter: 'Centre d\'activités',
        Identityauthentication: 'Vérification d\'identité',
        Completedverification: 'Vérification terminée',
        Tobeverified: 'À vérifier',
        SecuritySettings: 'Paramètres de sécurité',
        Lang: 'Choisir la langue',
        changeTheme: 'Changer de thème',
        helpcenter: 'Centre d\'aide',
        Aboutus: 'À propos de nous',
        out: 'Se déconnecter',
        outmsg: 'Confirmer la déconnexion',
        trustscore: 'Score de crédit',
    },
    welcome: {
        title1: 'Liquidité de marché de premier plan',
        tips1: '99% des ordres sont exécutés au meilleur prix',
        title2: '12 ans de confiance',
        tips2: 'Tradez des cryptomonnaies sur une plateforme fiable, où que vous soyez',
        title3: 'Avantages exclusifs VIP',
        tips3: 'Les VIP bénéficient de réductions sur les frais de trading, d\'échange et de retrait',
        title4: '100 000 USDT en trading simulé',
        tips4: 'Pratiquez le trading sans risque',
        bnt1: 'Inscrivez-vous et obtenez 10 USDT',
        bnt2: 'Se connecter',
    },
    with: {
        Withdrawcurrency: 'Retirer',
        currencyofwithdrawal: 'Monnaie de retrait',
        Withdrawaladdress: 'Adresse de retrait',
        Addwithdrawaladdress: 'Ajouter une adresse de retrait',
        Withdrawalquantity: 'Quantité de retrait',
        availablebalance: 'Solde disponible',
        WithdrawaladdressTips: 'Cette monnaie n\'a pas encore d\'adresse de retrait, voulez-vous en ajouter une ?',
        selectWithdrawaladdress: 'Sélectionner l\'adresse de retrait',
        Insufficientavailablebalance: 'Solde insuffisant',
        Withdrawingfiatcurrency: 'Retrait fiat',
        Withdrawaloffiatcurrency: 'Retirer des fonds fiat',
        Currentbalance: 'Solde actuel',
        Currencyreceived: 'Monnaie reçue',
        WithdrawingfiatcurrencyTips: 'Les retraits supérieurs à 200 USD arrivent rapidement',
        Withdrawalaccount: 'Compte de retrait',
        Fiatcontractaccount: 'Compte contrat fiat',
        Withdrawalamount: 'Montant du retrait',
        Youneedwithdrawmoney: 'Vous devez retirer',
        Youwillget: 'Vous recevrez',
        Withdrawimmediately: 'Retirer maintenant',
        mixAmount: 'Montant minimum de retrait ',
        subMsg: 'Soumission réussie, veuillez attendre l\'examen',
    },
}